import { Component, OnInit } from '@angular/core';
import { PageSize } from '../../../core/dto/page.size';
import { Router } from '@angular/router';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Pagination } from '../../../core/dto/pagination';
import { EmailIntegrationService } from '../../../core/services/email-integration.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AgentService } from '../../../core/services/agent.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import { SETTINGS } from '../../../core/config/common.settings';
import { EmailContentDrawerComponent } from '../../shared/email-content-drawer/email-content-drawer.component';
import { NzDrawerService } from 'ng-zorro-antd/drawer';

@Component({
  selector: 'app-view-agent-bookings',
  templateUrl: './view-agent-bookings.component.html',
  styleUrls: ['./view-agent-bookings.component.scss'],
})
export class ViewAgentBookingsComponent implements OnInit {
  filterType: any;
  // searchText: any;
  bookingData: any[] = []; // Initialize with dummy data
  breadcrumbs: any[] = [];
  pageSize = new PageSize();
  sortField: any;
  sortOrder: any = -1;

  skeletonTableColumns: any[] = [
    'Agent BookingId',
    'Agent Name',
    'Date and Time',
    'Agent Reference',
    'Vehicle Category',
    'Status',
    'Actions',
  ];
  loading = false;
  reading = false;

  constructor(
    private router: Router,
    private emailIntegrationService: EmailIntegrationService,
    private agentService: AgentService,
    private messageService: NzMessageService,
    private drawerService: NzDrawerService,
  ) {}

  ngOnInit(): void {
    this.setBreadcrumbs();
    this.getPagedTempBookings();
  }

  onTableParamsChange(params: NzTableQueryParams): void {
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;
    this.getPagedTempBookings();
  }

  setBreadcrumbs(): void {
    this.breadcrumbs = [
      {
        title: `Agent Bookings`,
        route: '/admin/agents/view-booking',
      },
    ];
  }

  sort(): void {
    this.sortOrder = this.sortOrder === 1 ? -1 : 1;
    this.getPagedTempBookings();
  }

  getPagedTempBookings(): void {
    this.loading = true;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      filters: {
        type: this.filterType,
      },
    });
    this.agentService
      .getPagedAgentsTempBookings(payload)
      .subscribe((res: any) => {
        this.loading = false;
        this.bookingData = res[0].data;
        this.pageSize.length = res[0].metadata[0]?.total;
      });
  }
  previewMail(data: any): void {
    if (data.content) {
      const drawerRef = this.drawerService.create({
        nzWidth: '40%',
        nzContent: EmailContentDrawerComponent,
        nzContentParams: {
          content: data.content,
        },
      });
    }
  }

  search(): void {
    this.getPagedTempBookings();
  }

  resetSearch(): void {
    // this.searchText = null;
    this.filterType = undefined;
    this.getPagedTempBookings();
  }

  readEmails(): void {
    this.reading = true;
    this.emailIntegrationService.readEmails().subscribe(
      (res: any) => {
        this.reading = false;
        if (res?.message) {
          this.messageService.create('info', res?.message);
        } else {
          this.getPagedTempBookings();
          this.messageService.create('success', 'Reading emails completed!');
        }
      },
      (e: any) => {
        this.reading = false;
        switch (e) {
          case e.error.chatgpt:
            this.messageService.create(
              'error',
              'Mail reading error. Please contact purple software agent',
            );
            break;
          case e.error.readMail:
            this.messageService.create(
              'error',
              'Please remove advertisement mails of Email account',
            );
            break;
          case e.error.mailLog:
            this.messageService.create(
              'error',
              'Can not log to mail account. Please contact purple software agent',
            );
            break;
          default:
            this.messageService.create(
              'error',
              'Unrecognized error. Please contact purple software agent',
            );
        }
      },
    );
  }

  cancel(): void {}

  convertToDate(dateString: string): any {
    // Remove 'BE' and any non-breaking space characters
    const cleanedDateString = dateString
      .replace(' BE', '')
      .replace(/\u00A0/g, ' ');

    // Parse the cleaned date string into a Date object
    const dateObj = new Date(cleanedDateString);

    // Check if the date object is valid
    if (isNaN(dateObj.getTime())) {
      return 'Invalid Date';
    }

    // Format the date object using DatePipe
    return dateObj;
  }

  navigateToAddBooking(data: any): void {
    if (data?.type === 'RENT') {
      this.router.navigate([`admin/booking-rent/add-edit`], {
        queryParams: { tempBookingId: data?._id },
      });
    } else {
      this.router.navigate([`admin/booking-transfer/add-edit`], {
        queryParams: { tempBookingId: data?._id },
      });
    }
  }

  rejectBooking(data: any): void {
    const tomorrow = moment().add(1, 'day').startOf('days');
    this.agentService
      .updateAgentTempBooking({
        _id: data?._id,
        status: 'REJECTED',
        expireAt: tomorrow,
      })
      .subscribe((res) => {
        this.getPagedTempBookings();
      });
  }

  hasPermissionWithStatus(perm: string, status: string): boolean {
    return _.includes(localStorage.getItem(SETTINGS.USER_PERMISSIONS), perm);
  }
}
